<template>
  <input
    type="email"
    autocomplete="email"
    :value="value"
    :placeholder="placeholder"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @input="
      event => {
        $emit('changedValue', event.target.value);
      }
    "
  />
</template>
<script>
export default {
  name: 'EmailInput',
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
input::placeholder {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.3px;
  color: #76767b;
}
input {
  padding: 16px 13px 14px;
  width: 100%;
  border: none;
  background: transparent;
}
</style>
